module.exports = __webpack_public_path__ + "img/vrch-s-kapuci_08_zluta.29b982a3.png";